export var PenumbraState;
(function (PenumbraState) {
    /* connection attempt pending */
    PenumbraState["Pending"] = "Pending";
    /* connection successful and active */
    PenumbraState["Connected"] = "Connected";
    /* connection inactive */
    PenumbraState["Disconnected"] = "Disconnected";
})(PenumbraState || (PenumbraState = {}));
